export default __webpack_public_path__ + "static/media/White Circle.afdbf0f3.svg";